import React from 'react'

const Gallery = () => {
    return (
        <>
            <div id='Topmargin1' >
                <div className='about_banner'>
                    <img src='GALLERY.png' className='about_image' alt=''></img>
                </div>
            </div>
            <div className='container'>
                <h3 className='text-center' style={{color:'#722e85',textTransform:'uppercase',justifyContent:'center',marginTop:'5%',marginBottom:'2%'}}>Gallery</h3>
                <div className='row'>
                    
                    <div className='col-md-3 col-sm-12 mt-2 mb-3'>
                        <img style={{width:'100%',border:'2px solid #e5097f'}} src='gallery_image1.png' alt=''></img>
                    </div>

                    <div className='col-md-3 col-sm-12 mt-2 mb-3'>
                        <img style={{width:'100%',border:'2px solid #e5097f'}} src='gallery_image2.png' alt=''></img>
                    </div>

                    <div className='col-md-3 col-sm-12 mt-2 mb-3'>
                        <img style={{width:'100%',border:'2px solid #e5097f'}} src='gallery_image3.png' alt=''></img>
                    </div>

                    <div className='col-md-3 col-sm-12 mt-2 mb-3'>
                        <img style={{width:'100%',border:'2px solid #e5097f'}} src='gallery_image4.png' alt=''></img>
                    </div>

                    <div className='col-md-3 col-sm-12 mt-2 mb-3'>
                        <img style={{width:'100%',border:'2px solid #e5097f'}} src='gallery_image5.png' alt=''></img>
                    </div>

                    <div className='col-md-3 col-sm-12 mt-2 mb-3'>
                        <img style={{width:'100%',border:'2px solid #e5097f'}} src='gallery_image6.png' alt=''></img>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Gallery